import React from "react"

import { Room } from "shared/types/Room"

import { DeleteRoomOverlay } from "./DeleteRoomOverlay"
import { useDeleteRoomOverlayModel } from "./hooks/useDeleteRoomOverlayModel"

export interface DeleteRoomOverlayPayload {
  projectID: string
  roomsToDelete: Room[]
}

export interface DeleteRoomOverlayConnectorProps {
  payload: DeleteRoomOverlayPayload
}

export const DeleteRoomOverlayConnector = React.memo(
  (props: DeleteRoomOverlayConnectorProps) => (
    <DeleteRoomOverlay autoFocus {...useDeleteRoomOverlayModel(props)} />
  )
)

declare module "shared/context/overlay/registry" {
  interface OverlayPayloadRegistry {
    DELETE_ROOM_OVERLAY: DeleteRoomOverlayPayload
  }
}
